module.exports = __webpack_public_path__ + "img/wan4-icon.67448dae.png";